export enum UserField {
  banned = 'banned',
  builtIn = 'builtIn',
  createdAt = 'createdAt',
  deleted = 'deleted',
  email = 'email',
  id = 'id',
  active = 'active',
  isAdmin = 'isAdmin',
  lastLoggedAt = 'lastLoggedAt',
  name = 'name',
  organizationId = 'organizationId',
  phone = 'phone',
  preferredLanguage = 'preferredLanguage',
  surname = 'surname',
  username = 'username',
}
